const data = [
  {
    Id: 1,
    img: require("../assets/images/faq/3.jpg"),
    date: "15 April 2023",
    writer: "Admin",
    hits: "10",
    short_description: [
      "This course is designed to start you on a path toward future studies in web development and design.",
    ],
  },
  {
    Id: 2,
    img: require("../assets/images/faq/2.jpg"),
    date: "15 April 2023",
    writer: "Admin",
    hits: "50",
    short_description: [
      "A Web Designing course belongs to the field of Computer Science and IT. It enables students to learn various techniques..",
    ],
  },
  {
    Id: 3,
    img: require("../assets/images/faq/2.jpg"),
    date: "15 April 2023",
    writer: "Admin",
    hits: "40",
    short_description: [
      "User interface design (UI) is the design for machines and software, such as mobile devices, computers.",
    ],
  },
  {
    Id: 4,
    img: require("../assets/images/faq/1.jpg"),
    date: "15 April 2023",
    writer: "Admin",
    hits: "15",
    short_description: [
      "Spoken English Courses are pursued by candidates from all levels to improve their communication skills.",
    ],
  },
  {
    Id: 5,
    img: require("../assets/images/faq/3.jpg"),
    date: "15 April 2023",
    writer: "Admin",
    hits: "35",
    short_description: [
      "A Web Development course belongs to the field of Computer Science and IT. It enables students to learn various techniques.",
    ],
  },
  {
    Id: 6,
    img: require("../assets/images/faq/2.jpg"),
    date: "15 April 2023",
    writer: "Admin",
    hits: "80",
    short_description: [
      "This course is designed to start you on a path toward future studies in web development and design.",
    ],
  },
];

export default data;
